import querystring from "query-string";
import axiosInstance, { errorHandler } from "./api";

const URL = "/tps/api";
const LIMITS_URL = `${URL}/kyc-limits`;

// KycLimitResource.getAllActiveKycLimits
const getLimitsListAll = axios => () => {
  return axios
    .get(`${LIMITS_URL}/active?page=0&size=2000`)
    .then(({ data }) => data)
    .catch(errorHandler);
};

// KycLimitResource.getAllMobileKycLimits
const getLimitsListMobile = axios => (page, size, filter = "", sort = "") => {
  return axios
    .get(
      `${LIMITS_URL}/mobile?${querystring.stringify({
        page,
        size,
        sort,
      })}`,
    )
    .then(({ data, headers }) => ({
      data,
      total: Number(headers["x-total-count"]),
    }))
    .catch(errorHandler);
};

// KycLimitResource.getAllDesktopKycLimits
const getLimitsListDesktop = axios => (page, size, filter = "", sort = "") => {
  return axios
    .get(
      `${LIMITS_URL}/desktop?${querystring.stringify({
        page,
        size,
        sort,
      })}`,
    )
    .then(({ data, headers }) => ({
      data,
      total: Number(headers["x-total-count"]),
    }))
    .catch(errorHandler);
};

// KycLimitResource.getKycLimit
const getLimitById = axios => (id = 1) => {
  return axios
    .get(`${LIMITS_URL}/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);
};

// KycLimitResource.createKycLimitLocal
const addLimit = axios => ({ limitName, limits, accountType, description }) => {
  return axios
    .post(`${LIMITS_URL}/local/add`, {
      limitName,
      limits,
      accountType,
      description,
    })
    .then(({ data }) => data)
    .catch(errorHandler);
};

// KycLimitResource.updateKycLimitLocal
const changeLimit = axios => ({ limitId, limits, limitName }) => {
  return axios
    .post(`${LIMITS_URL}/local/edit`, {
      limitId,
      limitName,
      limits,
    })
    .then(({ data }) => data)
    .catch(errorHandler);
};

// FstIrohaAccountResource.setFstIrohaAccountLimits
const changeLimitForUser = axios => payload => {
  return axios
    .post(`${URL}/fst-iroha-accounts/limits/set`, payload)
    .then(({ data }) => data)
    .catch(errorHandler);
};

export default {
  getLimitsListAll: getLimitsListAll(axiosInstance),
  getLimitsListMobile: getLimitsListMobile(axiosInstance),
  getLimitById: getLimitById(axiosInstance),
  getLimitsListDesktop: getLimitsListDesktop(axiosInstance),
  addLimit: addLimit(axiosInstance),
  changeLimit: changeLimit(axiosInstance),
  changeLimitForUser: changeLimitForUser(axiosInstance),
};
